import { render } from "./imageCropUpload.vue?vue&type=template&id=4e2c2aed&scoped=true"
import script from "./imageCropUpload.vue?vue&type=script&lang=js"
export * from "./imageCropUpload.vue?vue&type=script&lang=js"

import "./imageCropUpload.vue?vue&type=style&index=0&id=4e2c2aed&scoped=true&lang=less"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2c2aed"]])

export default __exports__